import Parse from "parse/dist/parse.min.js";
import { router } from "./router";

/**
 * handles errors in query
 * @param err
 */
export const handleParseError = (err) => {
	switch (err.code) {
		case Parse.Error.INVALID_SESSION_TOKEN:
			Parse.User.logOut()
			// This is a plain module function, not a component method --
			// there is no `this`; use the imported router directly.
			if (router.currentRoute.path !== "/login") {
				router.push({ path: "/login" }).catch(e =>
					console.error("couldnt redirect to login page " + e))
			}
			break;
	}
}
